import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import priceFormatter from '@upgrade/ui-utils/formatters/price';
import { StyledSlider, SliderContext, SliderGrow, RangeIndicator, RangeIndicatorContainer } from './styles';
import Text from '../Typography/Text';
import { EVENT_KEY_TAB } from '../utils/event-key-names';
import warning from '../utils/console-deprecated';

// Bypass the tab key event to allow the user to tab in and out of the slider
const restoreTabKey = event => {
  if (event.key === EVENT_KEY_TAB) {
    event.stopPropagation();
  }
};
const Slider = ({
  step,
  labelFormatter = priceFormatter,
  min = 0,
  max = 100,
  tooltip = false,
  ...props
}) => {
  warning('Slider / This component is deprecated. Please Slider/next component instead.');
  const sliderRef = useRef();

  // The following hook intercepts the keyboard events to restore the ability of
  // tab in and out of the slide component.
  // Once we migrate to a plain input range, then we can completely remove this
  // patch
  useEffect(() => {
    let unmount;
    if (sliderRef.current) {
      const handler = sliderRef.current.querySelector('.rangeslider__handle');
      handler.addEventListener('keydown', restoreTabKey);
      unmount = () => {
        handler.removeEventListener('keydown', restoreTabKey);
      };
    }
    return unmount;
  }, []);
  return /*#__PURE__*/React.createElement(SliderContext, {
    ref: sliderRef
  }, /*#__PURE__*/React.createElement(Text, {
    size: "xxs"
  }, labelFormatter(min)), /*#__PURE__*/React.createElement(SliderGrow, null, /*#__PURE__*/React.createElement(StyledSlider, _extends({
    hasStep: step,
    min,
    max,
    tooltip,
    step
  }, props)), step ? /*#__PURE__*/React.createElement(RangeIndicatorContainer, null, [...Array(Math.round(max / step) + 1).keys()].map(key => /*#__PURE__*/React.createElement(RangeIndicator, {
    key: key
  }))) : null), /*#__PURE__*/React.createElement(Text, {
    size: "xxs"
  }, labelFormatter(max)));
};
Slider.propTypes = {
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tooltip: PropTypes.bool,
  labelFormatter: PropTypes.func
};
export default Slider;
//# sourceMappingURL=index.js.map